module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"addResource":"Add resource","noResource":"No resource","reorder":"Reorder"},"fr":{"addResource":"Ajout ressource","noResource":"Aucune ressource","reorder":"Réorganiser"}}')
  delete Component.options._Ctor
}
